export default "__VITE_ASSET__I0AJKSL5__"